// Empty state for the feed — renders when items=[] is returned by the API.
// Matches design/project/scripts/feed.jsx EmptyState component.
import type { EmptyState } from "../api";

interface Props {
  emptyState: EmptyState | null;
}

export function FeedEmptyState({ emptyState }: Props) {
  const headline = emptyState?.headline ?? "Nothing here yet";
  const body = emptyState?.body ?? "Try a different filter — or be the first to post.";

  return (
    <div className="hub-empty" role="status" aria-live="polite">
      <div className="hub-empty__icon" aria-hidden="true">
        {/* Search glyph matching design/project/scripts/icons.jsx Icon.search */}
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="7" />
          <line x1="16.65" y1="16.65" x2="21" y2="21" />
        </svg>
      </div>
      <p className="hub-empty__headline">{headline}</p>
      <p className="hub-empty__body">{body}</p>
    </div>
  );
}
